import { useGetEHAppConfigQuery } from 'services/rtkQueries';

const useAppConfig = () => {
  return useGetEHAppConfigQuery(
    {},
    {
      selectFromResult: (result) => {
        return {
          data: result.data,
          isLoading: result.isLoading,
          error: result.error,
        };
      },
    }
  );
};

export default useAppConfig;
